/**
 * Outbound links used by the landing page. The store URLs are the live listings
 * already referenced by the previous footer — keep them in sync with the apps.
 */
export const landingLinks = {
  APP_STORE: "https://apps.apple.com/fr/app/laddition/id6502578813",
  GOOGLE_PLAY: "https://play.google.com/store/apps/details?id=ma.laddition.app",
  INSTAGRAM: "https://www.instagram.com/laddition_maroc",
};
